import React from 'react'

type CatalogCardsIconProps = {
  width?: number
  height?: number
}

export const CatalogCard2: React.FC<CatalogCardsIconProps> = ({
  width = 56,
  height = 56,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1106_800)">
        <rect
          x={8}
          y={8}
          width={40}
          height={40}
          rx={4}
          fill="white"
          shapeRendering="crispEdges"
        />
        <g clipPath="url(#clip0_1106_800)">
          <path
            d="M36.0001 19.131H34.1761V16.4079C34.1801 16.1879 34.0041 16.004 33.7841 16C33.7561 16 33.7281 16 33.7001 16.008L19.9201 18.7631C19.7321 18.7991 19.6001 18.971 19.6001 19.1629V39.6001C19.6001 39.8201 19.7801 40 20.0001 40H36.0001C36.2201 40 36.4001 39.8201 36.4001 39.6001V19.5308C36.4001 19.3109 36.2201 19.131 36.0001 19.131ZM33.3761 16.8957V19.131H22.1761L33.3761 16.8957ZM35.6001 39.2003H20.4001V19.9307H35.6001V39.2003Z"
            fill="url(#paint0_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.7841 15.9999C34.0041 16.0039 34.1801 16.1879 34.1761 16.4078V19.1309H36.0001C36.2201 19.1309 36.4001 19.3108 36.4001 19.5308V39.6001C36.4001 39.82 36.2201 39.9999 36.0001 39.9999H20.0001C19.7801 39.9999 19.6001 39.82 19.6001 39.6001V19.1629C19.6001 18.971 19.7321 18.799 19.9201 18.763L33.7001 16.0079C33.7281 15.9999 33.7561 15.9999 33.7841 15.9999ZM33.6547 15.8131C33.7068 15.7997 33.7552 15.7999 33.7796 15.7999C33.7812 15.7999 33.7828 15.7999 33.7841 15.7999H33.7878C34.1184 15.806 34.3811 16.0809 34.3761 16.4095V18.9309H36.0001C36.3305 18.9309 36.6001 19.2003 36.6001 19.5308V39.6001C36.6001 39.9305 36.3305 40.1999 36.0001 40.1999H20.0001C19.6698 40.1999 19.4001 39.9305 19.4001 39.6001V19.1629C19.4001 18.883 19.5926 18.6226 19.8817 18.5668C19.882 18.5667 19.8814 18.5668 19.8817 18.5668L33.6547 15.8131ZM33.3761 16.8956L22.1761 19.1309H33.3761V16.8956ZM33.1761 17.1395L24.2002 18.9309H33.1761V17.1395ZM20.6001 39.0002H35.4001V20.1306H20.6001V39.0002ZM35.6001 39.2002V19.9306H20.4001V39.2002H35.6001Z"
            fill="url(#paint1_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            d="M22.5362 29.7674H32.9882C33.3922 29.7674 33.4642 29.6115 33.4642 29.1636V23.1656C33.4642 22.7058 33.3922 22.5538 32.9762 22.5538H26.2962C25.0242 22.5538 23.7562 22.5538 22.4842 22.5538C22.1842 22.5538 22.0562 22.7018 22.0562 23.0417C22.0562 25.089 22.0562 27.1403 22.0562 29.1876C22.0562 29.6475 22.1562 29.7634 22.5322 29.7634L22.5362 29.7674ZM22.7362 28.6838V23.6415L26.9762 26.1606L22.7362 28.6798V28.6838ZM29.7162 24.5332C29.1122 24.8931 28.4882 25.2649 27.8682 25.6248C27.8082 25.6608 27.7322 25.6688 27.6922 25.6448C26.5642 24.981 25.4202 24.3013 24.3122 23.6415L23.9362 23.4175H31.5842L29.7122 24.5292L29.7162 24.5332ZM27.8442 26.6845C28.9162 27.3122 30.0002 27.96 31.0522 28.5838L31.6122 28.9157H23.9242C23.9242 28.9157 23.9482 28.8997 23.9562 28.8917L24.3482 28.6598C25.4282 28.016 26.5482 27.3482 27.6482 26.7005C27.7082 26.6645 27.7962 26.6565 27.8442 26.6845ZM28.5482 26.1606L32.7842 23.6415V28.6758L28.5482 26.1566V26.1606Z"
            fill="url(#paint2_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.5322 29.7634C22.1562 29.7634 22.0562 29.6474 22.0562 29.1875V23.0416C22.0562 22.7017 22.1842 22.5538 22.4842 22.5538H32.9762C33.3922 22.5538 33.4642 22.7057 33.4642 23.1656V29.1636C33.4642 29.6114 33.3922 29.7674 32.9882 29.7674H22.5362L22.5322 29.7634ZM22.4474 29.9614L22.4534 29.9674H32.9882C33.205 29.9674 33.4121 29.9276 33.5399 29.7504C33.5987 29.6689 33.628 29.5743 33.6439 29.48C33.6597 29.3859 33.6642 29.279 33.6642 29.1636V23.1656C33.6642 23.0474 33.6597 22.9384 33.6437 22.8428C33.6276 22.7471 33.5978 22.6513 33.5375 22.569C33.4071 22.3911 33.196 22.3538 32.9762 22.3538H22.4842C22.304 22.3538 22.1296 22.3985 22.0071 22.5386C21.8902 22.6723 21.8562 22.8537 21.8562 23.0416V29.1875C21.8562 29.4139 21.8763 29.6279 21.9995 29.7759C22.1144 29.9139 22.2804 29.9529 22.4474 29.9614ZM26.9762 26.1606L22.7362 23.6414V28.6797L26.9762 26.1606ZM22.9362 28.3283L26.5846 26.1606L22.9362 23.9929V28.3283ZM31.5842 23.4175H23.9362L24.3122 23.6414C25.4202 24.3012 26.5642 24.981 27.6922 25.6447C27.7322 25.6687 27.8082 25.6607 27.8682 25.6247C28.4277 25.3 28.9905 24.9654 29.539 24.6387C29.5916 24.6074 29.6441 24.5761 29.6964 24.5449C29.6981 24.5439 29.6998 24.5429 29.7014 24.5419L29.7162 24.5331L29.7122 24.5291L31.5842 23.4175ZM29.393 24.4928L29.3888 24.4886L30.8557 23.6175H24.663C25.6829 24.2246 26.7296 24.8461 27.7631 25.4544C27.7639 25.454 27.7647 25.4536 27.7653 25.4532L27.7678 25.4517C28.3115 25.1361 28.8585 24.8112 29.393 24.4928ZM31.0522 28.5837C30.7587 28.4097 30.4628 28.2339 30.1653 28.0571C29.3964 27.6001 28.6172 27.137 27.8442 26.6844C27.7962 26.6564 27.7082 26.6644 27.6482 26.7004C26.5679 27.3366 25.4683 27.992 24.4063 28.6251L24.3482 28.6597L23.9562 28.8916C23.9482 28.8996 23.9242 28.9156 23.9242 28.9156H31.6122L31.0522 28.5837ZM30.8825 28.7156C30.6109 28.5545 30.3374 28.392 30.0626 28.2287C29.3003 27.7757 28.5286 27.3171 27.7626 26.8684C27.7605 26.8687 27.7584 26.8693 27.7563 26.8699C27.7524 26.8711 27.7507 26.8721 27.7511 26.8719L27.7497 26.8727C26.7161 27.4814 25.6647 28.1078 24.645 28.7156H30.8825ZM28.5516 26.1586L32.7842 28.6757V23.6414L28.5516 26.1586ZM32.5842 23.993L28.9428 26.1586L32.5842 28.3241V23.993Z"
            fill="url(#paint3_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            d="M33.0802 32.0547C31.7482 32.0547 30.4202 32.0547 29.0882 32.0547C28.6962 32.0547 28.6162 32.2906 28.6162 32.6465C28.6162 33.926 28.6162 35.2056 28.6162 36.4852C28.6162 36.8411 28.6962 37.077 29.0882 37.077C29.5522 37.077 30.0162 37.077 30.4802 37.077H31.0762H31.6722H32.2682C32.5322 37.077 32.7962 37.077 33.0642 37.077C33.4642 37.077 33.5482 36.8451 33.5482 36.4932C33.5482 35.2056 33.5482 33.918 33.5482 32.6305C33.5482 32.3306 33.4922 32.0547 33.0802 32.0507V32.0547ZM32.7642 33.0143V36.1213H29.4002V33.0143H32.7642Z"
            fill="url(#paint4_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            d="M22.4761 35.0377C23.2401 35.0377 24.0041 35.0377 24.7681 35.0377C25.3081 35.0377 25.8521 35.0377 26.3921 35.0377C26.6921 35.0377 26.8641 34.8697 26.8681 34.5738C26.8681 34.4259 26.8281 34.3059 26.7481 34.222C26.6641 34.138 26.5401 34.094 26.3841 34.094H23.8921C23.4241 34.094 22.9561 34.094 22.4881 34.094C22.1961 34.094 22.0121 34.2739 22.0081 34.5578C22.0081 34.7018 22.0481 34.8218 22.1321 34.9057C22.2161 34.9897 22.3361 35.0337 22.4761 35.0337V35.0377Z"
            fill="url(#paint5_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.4761 35.0336V35.0376H26.3921C26.6921 35.0376 26.8641 34.8697 26.8681 34.5738C26.8681 34.4258 26.8281 34.3059 26.7481 34.2219C26.6641 34.1379 26.5401 34.0939 26.3841 34.0939H22.4881C22.1961 34.0939 22.0121 34.2739 22.0081 34.5578C22.0081 34.7017 22.0481 34.8217 22.1321 34.9056C22.2161 34.9896 22.3361 35.0336 22.4761 35.0336ZM22.2761 35.2084V35.2376H26.3921C26.5788 35.2376 26.7526 35.1848 26.8807 35.0598C27.0092 34.9346 27.0656 34.7624 27.0681 34.5765L27.0681 34.5738C27.0681 34.3909 27.0183 34.2155 26.8929 34.0839L26.8895 34.0804C26.7577 33.9487 26.5766 33.8939 26.3841 33.8939H22.4881C22.3006 33.8939 22.1281 33.9524 22.0009 34.0758C21.8733 34.1995 21.8107 34.3695 21.8081 34.5549L21.8081 34.5578C21.8081 34.7376 21.8586 34.915 21.9907 35.0471C22.0711 35.1275 22.1694 35.1801 22.2761 35.2084Z"
            fill="url(#paint6_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            d="M22.2641 32.9583C22.3481 32.9943 22.4361 32.9983 22.5081 32.9983C23.0241 32.9983 23.5361 32.9983 24.0521 32.9983H26.2161H26.2881C26.3121 32.9983 26.3401 32.9983 26.3641 32.9983C26.4121 32.9983 26.4641 32.9983 26.5161 32.9903C26.7321 32.9583 26.8721 32.7664 26.8681 32.5104C26.8641 32.2585 26.7121 32.0786 26.4921 32.0586C26.4641 32.0586 26.4361 32.0586 26.3881 32.0586H22.4681C22.4281 32.0586 22.3841 32.0586 22.3441 32.0666C22.1561 32.0986 22.0361 32.2505 22.0121 32.4825C21.9921 32.7104 22.0881 32.8903 22.2641 32.9663V32.9583Z"
            fill="url(#paint7_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.8681 32.5105C26.8721 32.7664 26.7321 32.9584 26.5161 32.9903C26.4641 32.9983 26.4121 32.9983 26.3641 32.9983H22.5081C22.494 32.9983 22.4793 32.9982 22.4641 32.9977C22.408 32.9958 22.3455 32.9889 22.2842 32.9663C22.2785 32.9642 22.2727 32.962 22.267 32.9596C22.266 32.9592 22.2651 32.9588 22.2641 32.9583V32.9663C22.2631 32.9659 22.2622 32.9655 22.2612 32.9651C22.2563 32.9629 22.2514 32.9607 22.2467 32.9583C22.1668 32.9195 22.1047 32.8583 22.0641 32.7805C22.021 32.6977 22.0021 32.596 22.0121 32.4825C22.0361 32.2506 22.1561 32.0986 22.3441 32.0666C22.3841 32.0586 22.4281 32.0586 22.4681 32.0586H26.4921C26.7121 32.0786 26.8641 32.2586 26.8681 32.5105ZM22.4641 33.1978V33.2705L22.1848 33.15C21.9137 33.0329 21.787 32.7601 21.8129 32.465L21.8131 32.4619C21.8434 32.1697 22.008 31.9223 22.3079 31.8699C22.3668 31.8586 22.4266 31.8586 22.4628 31.8586C22.4646 31.8586 22.4664 31.8586 22.4681 31.8586H26.5012L26.5102 31.8595C26.85 31.8903 27.0628 32.1723 27.0681 32.5073C27.0732 32.8368 26.885 33.1376 26.546 33.1881C26.4789 33.1984 26.4141 33.1983 26.3685 33.1983L22.5081 33.1983C22.4948 33.1983 22.48 33.1982 22.4641 33.1978Z"
            fill="url(#paint8_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            d="M26.4721 36.1413C26.2801 36.1373 26.0921 36.1373 25.9001 36.1373H22.5721H22.5321C22.4921 36.1373 22.4521 36.1373 22.4121 36.1373C22.1721 36.1573 22.0041 36.3533 22.0081 36.6172C22.0081 36.8891 22.1841 37.077 22.4281 37.077C22.7441 37.077 23.0641 37.077 23.3801 37.077C23.5281 37.077 23.6761 37.077 23.8241 37.077H24.9201C25.4081 37.077 25.8921 37.077 26.3801 37.077H26.4081C26.4761 37.077 26.5601 37.077 26.6321 37.037C26.8041 36.9451 26.8881 36.7651 26.8601 36.5412C26.8281 36.2893 26.6881 36.1413 26.4681 36.1373L26.4721 36.1413Z"
            fill="url(#paint9_linear_1106_800)"
            fillOpacity={0.6}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.4121 36.1373H25.9001C25.996 36.1373 26.0908 36.1373 26.1857 36.1378C26.2783 36.1383 26.3708 36.1393 26.4643 36.1412C26.4669 36.1412 26.4695 36.1413 26.4721 36.1413L26.4681 36.1373C26.4695 36.1374 26.4709 36.1374 26.4722 36.1374C26.4734 36.1375 26.4747 36.1375 26.4759 36.1375C26.6278 36.1427 26.7408 36.2175 26.8053 36.3483C26.8323 36.4031 26.8508 36.4677 26.8601 36.5412C26.8881 36.7651 26.8041 36.9451 26.6321 37.037C26.5601 37.077 26.4761 37.077 26.4081 37.077H22.4281C22.1841 37.077 22.0081 36.8891 22.0081 36.6172C22.0041 36.3533 22.1721 36.1573 22.4121 36.1373Z"
            fill="url(#paint10_linear_1106_800)"
            fillOpacity={0.6}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1106_800"
          x={0}
          y={0}
          width={56}
          height={56}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1106_800"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1106_800"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1106_800"
          x1={19.8551}
          y1={16.3896}
          x2={42.5544}
          y2={26.1661}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1106_800"
          x1={19.8551}
          y1={16.3896}
          x2={42.5545}
          y2={26.1661}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1106_800"
          x1={22.2293}
          y1={22.6709}
          x2={31.6155}
          y2={31.8041}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1106_800"
          x1={22.2293}
          y1={22.6709}
          x2={31.6156}
          y2={31.8041}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1106_800"
          x1={28.6911}
          y1={32.1323}
          x2={34.4808}
          y2={35.6277}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1106_800"
          x1={22.0818}
          y1={34.1093}
          x2={22.7869}
          y2={36.3435}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1106_800"
          x1={22.0819}
          y1={34.1092}
          x2={22.787}
          y2={36.3435}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1106_800"
          x1={22.0833}
          y1={32.0738}
          x2={22.7831}
          y2={34.3002}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1106_800"
          x1={22.0832}
          y1={32.0739}
          x2={22.7831}
          y2={34.3003}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1106_800"
          x1={22.0818}
          y1={36.1526}
          x2={22.7818}
          y2={38.3788}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1106_800"
          x1={22.0818}
          y1={36.1526}
          x2={22.7818}
          y2={38.3788}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00F5" />
          <stop offset={1} stopColor="#25C1F3" />
        </linearGradient>
        <clipPath id="clip0_1106_800">
          <rect
            width={16.8}
            height={24}
            fill="white"
            transform="translate(19.6001 16)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
